// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarSectionHeader_root","icon":"SidebarSectionHeader_icon"};